import { toEnum } from '@tryiris-ai/js-types';
import { Filter } from './types.js';

/**
 * Transforms the specified value to a `Filter` enumeration.
 *
 * @param value - The value to be transformed.
 * @returns The transformed `Filter` enumeration or `Filter.All`.
 */
export const toFilter = (value: unknown): Filter => toEnum(Filter, value, { default: Filter.All });
